import { render, staticRenderFns } from "./EyesPhone.vue?vue&type=template&id=8d74f4fc&scoped=true&"
import script from "./EyesPhone.vue?vue&type=script&lang=js&"
export * from "./EyesPhone.vue?vue&type=script&lang=js&"
import style0 from "./EyesPhone.vue?vue&type=style&index=0&id=8d74f4fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d74f4fc",
  null
  
)

export default component.exports